import axios from 'axios';

interface SkipProfileImageResponse {
  skippedProfileImageUpload: boolean;
}

export default async function userSkipImage(): Promise<boolean | null> {
  try {
    const response = await axios.post<SkipProfileImageResponse>('/api/user/SkipProfileImageUpload', []);

    return response.data?.skippedProfileImageUpload ?? null;
  } catch (error) {
    console.error('Error skipping profile image upload:', error);
    return null;
  }
}
